import { Box, css, List, ListItem, styled, Tooltip } from '@mui/material';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const VariablesPickerStyled = styled(Tooltip, { name: 'VariablesPicker' })``;

export const VariablesPickerContentStyled = styled(Box, { name: 'VariablesPickerContentStyled' })`
  ${({ theme }) => css`
    background: ${theme.palette.grey[600]};
    padding: ${theme.spacing(3)};
    outline: 1px solid ${theme.palette.primary.main};
    border-radius: ${theme.spacing(1)};
  `}
`;

export const SearchContainerStyled = styled(Box, { name: 'SearchContainer' })`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacing(3)};
  `}
`;

export const VariablesPickerContainerStyled = styled(Box, { name: 'VariablesPickerContainer' })`
  ${({ theme }) => css`
    overflow: auto;
    max-height: 300px;
    padding-right: ${theme.spacing(1.5)};
    margin-right: -${theme.spacing(1.5)};
  `}
`;

export const VariablesPickerEmptyStateStyled = styled(Box, { name: 'VariablesPickerEmptyStateStyled' })`
  ${({ theme }) => css`
    padding-top: ${theme.spacing(1.5)};
    padding-bottom: ${theme.spacing(6)};
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
  `}
`;

export const VariablesPickerEmptyStateIconStyled = styled(Box, { name: 'VariablesPickerEmptyStateIconStyled' })`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacing(4)};
  `}
`;
export const VariablesPickerEmptyStateTitleStyled = styled(Box, { name: 'VariablesPickerEmptyStateTitleStyled' })``;

export const VariablesPickerDropdownListStyled = styled(
  (props: AccordionProps) => <MuiAccordion disableGutters elevation={0} {...props} />,
  { name: 'VariablesPickerDropdownList' }
)`
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 0, 1)};

    & > div {
      // need this because of wrong re-calculation of arrow when placement "right"/"left"
      transition-duration: 0ms !important;
    }

    &:before {
      opacity: 0;
    }
  `}
`;

export const VariablesCategoryLabelStyled = styled(
  (props: AccordionSummaryProps) => (
    <MuiAccordionSummary
      expandIcon={<ExpandMoreIcon sx={theme => ({ color: theme.palette.grey['200'] })} />}
      {...props}
    />
  ),
  { name: 'VariablesCategoryLabel' }
)`
  ${({ theme }) => css`
    padding: 0;
    min-height: 24px;
    max-height: 24px;

    &.Mui-expanded {
      border-radius: ${theme.spacing(1, 1, 0, 0)};
    }

    & .MuiAccordionSummary-expandIconWrapper {
      transform: rotate(-90deg);
    }

    & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
      transform: rotate(0deg);
    }

    & .MuiAccordionSummary-content {
      margin: 0;
    }
  `}
`;

export const VariableListStyled = styled(List, { name: 'VariableList' })`
  ${({ theme }) => css`
    padding: ${theme.spacing(2, 0, 0)};
  `}
`;

export const VariableItemListStyled = styled(ListItem, { name: 'VariableItemList' })`
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 0, 1, 4)};

    margin: 0;
    overflow: hidden;
    flex-direction: column;
    align-items: start;

    &:hover {
      background-color: transparent;
    }

    &:last-of-type {
      padding-bottom: 0;
    }
  `}
`;

export const VariableItemListSubHeaderStyled = styled(Box, { name: 'VariableItemListSubHeader' })`
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 0, 1.25)};
  `}
`;
